
export function convertKeyboardLayout(text: string, fromEngToRus = true) {
  const englishChars = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:"ZXCVBNM<>?~@#$^&|';
  const russianChars = 'йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё"№;:?/';

  const fromChars = fromEngToRus ? englishChars : russianChars;
  const toChars = fromEngToRus ? russianChars : englishChars;

  return text.split('').map(char => {
    const index = fromChars.indexOf(char);
    return index !== -1 ? toChars[index] : char;
  }).join('');
}
